import React from "react";
import "../css/Home.css";

const Home = () => {
  return (
    <section className="hero">
      <div className="hero-container">

        {/* LEFT CONTENT */}
        <div className="hero-content">

          <div className="hiring-badge">
            <span className="badge">We’re hiring!</span>
            <span className="join">
              Join our team <span>→</span>
            </span>
          </div>

          <h1>
            Experience the power of
            <br />
            seamless customer
            <br />
            service outsourcing
          </h1>

          <button className="call-btn">
            📞 Call Us 0844-822-6536
          </button>

          <p className="privacy-text">
            We care about your data in our{" "}
            <a href="#">privacy policy</a>.
          </p>
        </div>

        {/* RIGHT IMAGE CARD */}
        <div className="hero-image">
          <img
            src="nimbus-banner.jpg"
            alt="Customer Experience"
          />

          <div className="image-overlay">
            <p className="overlay-text">
              We elevate your customer’s experience
            </p>
            <a href="#" className="learn-more">
              Learn more
            </a>

            <div className="dots">
              <span className="active"></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Home;
